import axios from '../../http';
import { handleGetRequestParams } from '../../common/js/util'
class ShoppingCart {
  // 详情页添加购物车
  postAddShoppingCart(data) {
    let url = `/api/xb/shopping/cart/add`
    return axios.post(url, data).then((res) => {
      return Promise.resolve(res.data)
    })
  }
  // 获取购物车商品列表
  getShoppingCartCommodityList(options) {
    let url = `/api/xb/shopping/cart/list?`
    url += handleGetRequestParams(options)
    return axios.get(url).then((res) => {
      return Promise.resolve(res.data)
    })
  }
  // 修改购物车商品数量
  updateCommodityNum(data) {
    const url = `/api/xb/shopping/cart/update`
    return axios.post(url, data).then((res) => {
      return Promise.resolve(res.data)
    })
  }
  // 删除所勾选的购物车商品
  deleteSelectedCommodity(data) {
    const url = `/api/xb/shopping/cart/del`
    return axios.post(url, data).then((res) => {
      return Promise.resolve(res.data)
    })
  }
  // 清空购物车
  clearShoppingCart() {
    const url = `/api/xb/shopping/cart/empty`
    return axios.post(url).then((res) => {
      return Promise.resolve(res.data)
    })
  }
  // 添加到我的收藏
  addCommodityToCollection(data) {
    const url = `/api/xb/collection/insert`
    return axios.post(url, data).then((res) => {
      return Promise.resolve(res.data)
    })
  }
  // 结算--确认订单
  confirmOrder(data) {
    const url = `/api/xb/order/info`
    return axios.post(url, data).then((res) => {
      return Promise.resolve(res.data)
    })
  }
  // 结算--提交订单
  submitOrder(data) {
    const url = `/api/xb/order/confirm`
    return axios.post(url, data).then((res) => {
      return Promise.resolve(res.data)
    })
  }
  // 选择地址计算运费
  getFreightWithAddress(data) {
    const url = `/api/index/create/freight`
    return axios.post(url, data).then((res) => {
      return Promise.resolve(res.data)
    })
  }
  // 库存信息
  getStockInfo(data) {
    const url = `/api/index/storage`
    return axios.post(url, data).then((res) => {
      return Promise.resolve(res.data)
    })
  }
  // 计算购物车总价
  totalPrice(data) {
    const url = `/api/xb/shopping/cart/calculate`
    return axios.post(url, data).then((res) => {
      return Promise.resolve(res.data)
    })
  }
}
export default ShoppingCart
